var getSuitName = function (suit) {
    switch (suit) {
        case "H":
            return "hearts";
        case "D":
            return "diamonds";
        case "C":
            return "clubs";
        case "S":
            return "spades";
        default:
            return "";
    }
};
var getColor = function (suit) {
    return suit === "H" || suit === "D" ? "Red" : "Black";
};
export var getCardDetails = function (card) {
    var value = card.slice(0, -1);
    var suit = card.slice(-1);
    return {
        value: value,
        suit: getSuitName(suit),
        color: getColor(suit),
    };
};
